import styled from "styled-components";

export const Container = styled.main`
  width: 100%;
  padding: 0 28px;
  display: flex;
  flex-direction: column;
  align-items: center;
`;

export const TitleBox = styled.h1`
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-bottom: 179px;
`;

export const QuestionSpan = styled.span`
  /* font-family: "SHSN-B"; */
  text-align: center;
  font-size: 25px;
  line-height: 37px;
  letter-spacing: 1.25px;
  color: #000000;
`;

export const BlueSpan = styled.strong`
  color: #3f7ae2;
`;

export const RedSpan = styled.strong`
  color: #ed706b;
`;

export const QuestionForm = styled.form`
  display: flex;
  flex-direction: column;
  align-items: center;
`;

export const QuestionInput = styled.input`
  width: 374px;
  height: 57px;
  border: 0;
  border-bottom: 2px solid #c6c8cc;
  margin-bottom: 120px;
`;

export const LoadingSpan = styled(QuestionSpan)`
  font-size: 15px;
  line-height: 22px;
  letter-spacing: 0.75px;
  margin-top: 30px;
`;
